import {TableContainer, TableBody, TableCell, TableHead, TableRow, Paper, Table, Grid} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_TIME, TAB_WINTER} from './StatsCommon.js';
import StatsFilter from './StatsFilter.js';
import StatsRow from './StatsRow.js';
import {COMM_OK} from '../WsR2.js';

const StatsWinterTable = (() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function winterSrc() {
		let prev_month = -1, prev_year = -1, i;
		let ret = [];

		if (!gStorage.stats.obsList)
			return null;

		let ol = gStorage.stats.obsList.length;

		for (i = ol - 1; i >= 0; i--) {
			let obs = gStorage.stats.obsList[i];
			const bg = obs.lifer ? '#cbffe2' : '#ffffff';
			const ts = new Date(obs.start_t * 1000.0);
			const month = ts.getMonth();
			const year = ts.getYear();

// 			console.log(prev_year + 1900, prev_month, '=>', year + 1900,  month);

			if (prev_year <= 0 || prev_year - year > 1 || (year !== prev_year && (prev_month !== 0 || prev_month !== 1) && month !== 11) || (prev_month - month > 7)) {
				const start_year = month >= 11 ? year : year - 1;
				let j, n;

				n = 1;

				for (j = i - 1; j >= 0; j--) {
					let obs2 = gStorage.stats.obsList[j];
					const ts2 = new Date(obs2.start_t * 1000.0);
					const month2 = ts2.getMonth();
					const year2 = ts2.getYear();

					if (year - year2 > 1 || (year !== year2 && (month !== 0 || month !== 1) && month2 !== 11) || (month - month2 > 7))
						break;

					n++;
				}

				if (prev_month !== - 1)
					ret.push(
						<TableRow key={((-start_year * 12 + month) * 2) - 1}>
							<TableCell colSpan={4}>
								&nbsp;
							</TableCell>
						</TableRow>);

				ret.push(
					<TableRow key={(-start_year * 12 + month) * 2} style={{backgroundColor: '#f0f0f0'}}>
						<TableCell colSpan={4}> 
							{(start_year + 1900) + ' - ' + (start_year + 1900 + 1) + ' ' + n + ' ' + t('stats.species')}
						</TableCell>
					</TableRow>);
			}

			ret.push(
				<StatsRow
					key	= {i + 1}
					bgcolor	= {bg}
					row_n	= {i + 1}
					obs	= {obs}
				/>);

			prev_year = year;
			prev_month = month;
		}

		return ret;
	}

	return (
		<TableContainer component={Paper} elevation={0}>
			<Table size='small'>
				<TableHead>
					<TableRow>
						<TableCell>#</TableCell>
						<TableCell>{t('main.time')}</TableCell>
						<TableCell>{t('main.species')}</TableCell>
						<TableCell>{t('main.location')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{winterSrc()}
				</TableBody>
			</Table>
		</TableContainer>
	);
});

const StatsWinter = observer((props) => {
	const gStorage = useGlobalStorage();

	function winterAddLeftEnabled() {
		return gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.rightList.tab !== TAB_WINTER ||
				gStorage.stats.rightList.country !== gStorage.stats.country.id);
	}

	function winterAddLeft() {
		gStorage.stats.setLeftList({...gStorage.stats.leftList, tab: TAB_WINTER, year: 0, list: gStorage.stats.obsList.slice()});
	}

	function winterAddRightEnabled() {
		return gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.leftList.tab !== TAB_WINTER ||
				gStorage.stats.leftList.country !== gStorage.stats.country.id);
	}

	function winterAddRight() {
		gStorage.stats.setRightList({...gStorage.stats.rightList, tab: TAB_WINTER, year: 0, list: gStorage.stats.obsList.slice()});
	}

	function winterListRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('winterListRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('winterListRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_WINTER)
			return;

//		console.log('winterListRxWs', msg);
		gStorage.stats.setObsList(msg.data.list);
	}

	function loadWinterList() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'month',
			op: 'winter',
			data: {
				country: gStorage.stats.country.id,
				user: gStorage.conn.user.id,
			},
		};

//		console.log('loadWinterList', msg);
		gStorage.conn.ws.send(msg, winterListRxWs);
	}

	if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_WINTER) 
		return null;

	if (!gStorage.stats.obsList && gStorage.conn.online) 
		loadWinterList();

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
			<Grid size={{xs: 12}} align={'center'}>
				<StatsFilter 
					loc = {{country: {
							value: gStorage.stats.country,
							style: {width: 200}
						}
					}}
					compare = {{
						leftIsEnabled: winterAddLeftEnabled(),
						leftAdd: winterAddLeft,
						rightIsEnabled: winterAddRightEnabled(),
						rightAdd: winterAddRight,
						pos: 'country'
					}}

				/>
			</Grid>
			<StatsWinterTable/>
		</Grid>
	);
});

export default StatsWinter;
